import request from '@/utils/request';

export function CastCrewAPI() {
    return {
        fileAvatarUpload: data => {
            return request({
                url: '/admin/upload/avatar',
                method: 'post',
                data
            });
        },
        // 列表
        getCastCrewList: params => {
            return request({
                url: '/admin/novel/cast_crew/list',
                method: 'get',
                params,
            });
        },
        //新增
        CastCrewAdded: data => {
            return request({
                url: '/admin/novel/cast_crew/edit',
                method: 'post',
                data
            });
        },
        // 详情数据
        detailsList: params => {
            return request({
                url: `/admin/novel/cast_crew/info?id=${params}`,
                method: 'get',
            });
        },
    };
}
